import 'babel-polyfill';
import Vue from "vue";
import VueRouter from "vue-router";
import router from "./router.js";
import {
  BackTop,
  Card,
  Carousel,
  Layout,
  Icon,
  Menu,
  List
} from "ant-design-vue";
import "ant-design-vue/dist/antd.min.css";
import App from "./App.vue";

Vue.use(VueRouter);
Vue.use(BackTop);
Vue.use(Card);
Vue.use(Carousel);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(List);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");